import React, {useEffect, useState} from 'react';
import {Box, Button, HStack, Img, Spinner, Stack, Text} from '@chakra-ui/react';
import colorAlpha from 'color-alpha';
import {Link, useNavigate, useParams, useSearchParams} from 'react-router-dom';
import axios from "axios";
import {motion} from 'framer-motion';

const MotionedBox = motion(Box);

const Technology  = () => {
    const [searchParams] = useSearchParams();
    const slug = searchParams.get('investor') ?? undefined;
    const [isLoading, setIsLoading] = useState(false)
    const [insightsTechnologyPageData, setInsightsTechnologyPageData] = useState(undefined)
    const {pageCount} = useParams();
    const [startIndex, setStartIndex] = useState(pageCount || 0)
    const navigate = useNavigate();
    const scrollToTop = () => {
        // const filters = document.getElementById("filters");
        // window.scrollTo({
        //     top: filters.offsetTop,
        //     behavior: "smooth"
        // });
    };
    useEffect(() => {
        const fetchTechnologyPageData = async () => {
            setIsLoading(true)
            const insightsTechnologyPageData = await axios.get(slug ? `/wp-admin/admin-ajax.php?action=get_insights&insights_start=${startIndex}&insights_include_podcasts=no&insights_category_id=177&team_slug=${slug}` : `/wp-admin/admin-ajax.php?action=get_insights&insights_start=${startIndex}&insights_include_podcasts=no&insights_category_id=177`).then(resp => {
                return resp.data;
            });
            setIsLoading(false)
            setInsightsTechnologyPageData(insightsTechnologyPageData)
        }
        fetchTechnologyPageData()
    }, [slug, startIndex])

    // if (!insightsTechnologyPageData || isLoading) {
    //     return (
    //         <Box my={20} width="100%" textAlign="center">
    //             <Spinner color='blue.600' size='xl'/>
    //         </Box>
    //     )
    // }

    if (insightsTechnologyPageData?.length === 0) {
        return (
            <Text
                fontSize={'md'}
                fontWeight={'semibold'}
                lineHeight={'10px'}
                mb={'10'}
                mt={'4'}
            >
                No results matched your search
            </Text>
        )
    }

    return (
        <>
            <Box pr={{base: '0', md: '21px'}}>
                {insightsTechnologyPageData?.map((item) => (
                    <TechnologyItem key={item.ID} {...item} />
                ))}
            </Box>
            <HStack spacing='24px'>
                {startIndex > 0 &&
                    <Button
                        size={'sm'}
                        py={'18px'}
                        minW={'100px'}
                        textColor={'black'}
                        fontWeight={'semibold'}
                        fontSize={'xs'}
                        variant={'brand'}
                        borderRadius={'full'}
                        colorScheme={'brand'}
                        borderColor={'rgba(11, 46, 251, 0.5)'}
                        onClick={() => {
                            scrollToTop()
                            setStartIndex(startIndex - 5)
                            navigate(startIndex ? `/insights/page/${startIndex - 5}` : '/insights');
                        }}
                    >
                        Previous
                    </Button>
                }
                <Button
                    size={'sm'}
                    py={'18px'}
                    minW={'100px'}
                    textColor={'black'}
                    fontWeight={'semibold'}
                    fontSize={'xs'}
                    variant={'brand'}
                    borderRadius={'full'}
                    colorScheme={'brand'}
                    borderColor={'rgba(11, 46, 251, 0.5)'}
                    onClick={() => {
                        scrollToTop()
                        setStartIndex(parseInt(startIndex.toString()) + 5)
                        navigate(`/insights/page/${parseInt(startIndex.toString()) + 5}`);
                    }}
                >
                    Next
                </Button>
                {(!insightsTechnologyPageData || isLoading) && (
                    <Box my={20} width="100%" textAlign="center">
                        <Spinner color='blue.600' size='sm'/>
                    </Box>
                )}
            </HStack>
        </>
    );
};

export default Technology;

const TechnologyItem = (props) => {
    const {
        ID,
        post_title,
        post_excerpt,
        post_date,
        author_name,
        author_photo,
        post_name,
        url,
        author_link
    } = props;
    return (
        <MotionedBox
            initial={{opacity: 0}}
            animate={{opacity: 1}}
            transition={{
                delay: 0.3,
                default: {duration: 0.5},
            }}
        >
            <Box pb={'20px'} mb={'20px'} borderBottom={'1px solid #A1B6E5'}>
                <Link itemID={ID} to={`${author_link}`}>
                    <Stack mb={'13px'} spacing={'17px'} direction={'row'} align={'center'}>
                        <Img
                            w={'60px'}
                            h={'60px'}
                            alt={post_name}
                            borderRadius={'full'}
                            src={author_photo}
                        />
                        <Text
                            fontWeight={500}
                            fontSize={'16px'}
                            lineHeight={'32px'}
                            color={'brand.700'}
                        >
                            {author_name}
                        </Text>
                    </Stack>
                </Link>
                <Link itemID={ID} to={`${url}`}>
                    <Text
                        mb={'20px'}
                        lineHeight={{base: '21.6px', md: '28.8px'}}
                        fontSize={{base: '18px', md: '24px'}}
                        letterSpacing={'-0.01em'}
                        maxW={'656px'}
                        sx={{
                            '&:hover': {
                                textDecoration: 'underline'
                            },
                        }}
                    >
                        {post_title}
                    </Text>
                    <Text
                        maxW={'656px'}
                        fontSize={'14px'}
                        lineHeight={'16.8px'}
                        letterSpacing={'-0.01em'}
                        color={colorAlpha('#000000', 0.5)}
                        mb={'23px'}
                        dangerouslySetInnerHTML={{
                            __html: post_excerpt,
                        }}
                        noOfLines={4}
                    ></Text>
                    <Text fontSize={'12px'} lineHeight={'13.2px'} color={colorAlpha('#000000', 0.5)}>
                        {post_date}
                    </Text>
                </Link>
            </Box>
        </MotionedBox>
    );
};
